// @ts-nocheck
import React from 'react'
import { ReactComponent as ClockIcon } from './icons/ClockIcon.svg'
import { ReactComponent as PlayIcon } from './icons/PlayIcon.svg'
import { ReactComponent as StopIcon } from './icons/StopIcon.svg'
import 'typeface-roboto'
import { Draggable } from 'react-touch-draggable'

import './App.css'
import { Badge, BadgeContainer } from '@progress/kendo-react-indicators'

import { w3cwebsocket as W3CWebSocket, IMessageEvent } from 'websocket'
import { convertToCentralTime } from '../../utils'
import { getTotalTime, timeObject } from './utils'
import ReactDOM from 'react-dom'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import { getAPIURL, getBaseURL } from '../../GlobalComponents/URLs'

const STAGES_URL = `${getBaseURL()}webapi/tags/stages/`
const TECHS_URL = `${getBaseURL()}webapi/tags/techs/`

interface timerObject {
    start?: Date
}

interface timerLog {
    timePassed: timeObject
    stage: string
    tech: string
}
const useTimer = (
    orderTagId: number,
    recordId?: number
): [
    timerObject,
    boolean,
    Array<any>,
    Array<any>,
    Array<any>,
    (tech: string, stage: string) => void,
    (tech: string, stage: string, newStage: string) => void,
    (stage: string, tech: string) => void,
    string
] => {
    const [time, setTime] = React.useState<timerObject>({})
    const [ticking, setTicking] = React.useState(false)
    const [techTimers, setTechTimers] = React.useState<Array<any>>([])
    const [eventLog, setEventLog] = React.useState<Array<any>>([])
    const [timerLog, setTimerLog] = React.useState<Array<any>>([])
    const [orderStage, setOrderStage] = React.useState('')
    const [reconFlag, setReconFlag] = React.useState([])
    const reconnect = () => {
        client.current = null
        setReconFlag([])
    }
    const createWS = React.useCallback(() => {
        // return new W3CWebSocket('ws://127.0.0.1:8000');
        return new W3CWebSocket(
            `${getAPIURL().replace('https:', 'wss:')}tags/techTimers?orderTagId=${orderTagId}`
        )
    }, [])
    const client = React.useRef<any>(null)

    const toggleTimer = React.useCallback(
        (tech: string, stage: string) => {
            let currentTimer = techTimers.find(
                (timer) => timer.stage === stage && timer.tech === tech
            )
            if (!currentTimer) {
                let payload = {
                    // time isn't used in the API... that I can tell. I'm afraid to remove it completely, though
                    time: time,
                    type: 'start',
                    stage,
                    tech,
                    orderTagId: orderTagId,
                    // startTime isn't used in the API... that I can tell. I'm afraid to remove it completely, though
                    // Now.Date is used on the server side
                    startTime: convertToCentralTime(new Date()),
                    recordId,
                }
                client.current.send(JSON.stringify(payload))
                setTime((time) => {
                    time.start = convertToCentralTime(new Date())
                    return { ...time }
                })
                setTicking(true)
            } else {
                let payload = {
                    // timer isn't used in the API... that I can tell. I'm afraid to remove it completely, though
                    timer: time,
                    type: 'stop',
                    orderTagId: orderTagId,
                    stage,
                    tech,
                    recordId,
                }
                client.current.send(JSON.stringify(payload))
                setTicking(false)
            }
        },
        [ticking, time, techTimers]
    )

    const switchStage = (tech: string, stage: string, newStage: string) => {
        let payload = {
            type: 'switch',
            tech,
            stage,
            orderTagId: orderTagId,
            newStage,
            recordId,
        }
        client.current.send(JSON.stringify(payload))
    }

    const changeOrderStage = (stage: string, tech: string) => {
        let payload = {
            type: 'changeStage',
            stage,
            tech,
            orderTagId: orderTagId,
            recordId,
        }
        client.current.send(JSON.stringify(payload))
    }

    React.useEffect(() => {
        if (!client.current) client.current = createWS()
        client.current.onopen = () => {
            if (!client.current.readyState) return
            // client.current.send("test")
            setEventLog((eventLog) => {
                return [...eventLog, 'WebSocket Client Connected']
            })
        }
        client.current.onmessage = (message: IMessageEvent) => {
            let info = JSON.parse(message.data as string)
            if (info.type === 'start') {
                setTechTimers((techTimers) => {
                    // techTimers.push(JSON.parse(message.data as string))
                    return [
                        ...techTimers,
                        {
                            startTime: convertToCentralTime(new Date()),
                            relativeStartTime: info.timer,
                            stage: info.stage,
                            tech: info.tech,
                        },
                    ]
                })
            } else if (info.type === 'init') {
                setTechTimers(
                    info.activeTimers.map((timer: any) => ({
                        startTime: convertToCentralTime(new Date(timer.Start)),
                        relativeStartTime: new Date(timer.Start),
                        stage: timer.Stage,
                        tech: timer.TechUsername,
                    }))
                )
            } else if (info.type === 'stop') {
                let startTimer = techTimers.find(
                    (tTimer) => tTimer.stage === info.stage && tTimer.tech === info.tech
                )
                let timeElapsed = getTotalTime(startTimer.startTime, new Date())
                let newTechLog: timerLog = {
                    timePassed: timeElapsed,
                    stage: info.stage,
                    tech: info.tech,
                }
                setTechTimers((techTimers) => {
                    // techTimers.push(JSON.parse(message.data as string))
                    // this should be based on userID
                    return techTimers.filter(
                        (tTimer) => tTimer.stage !== info.stage || tTimer.tech !== info.tech
                    )
                })
                setTimerLog((timerLog) => {
                    return [...timerLog, newTechLog]
                })
            } else if (info.type === 'switch') {
                setTechTimers((timers) => {
                    // let currentTimer = timers.find(timer => timer.tech === info.tech && timer.stage === info.stage)
                    // currentTimer.stage = info.newStage
                    return timers.map((timer) =>
                        timer.tech === info.tech && timer.stage === info.stage
                            ? {
                                  ...timer,
                                  stage: info.newStage,
                                  //   startTime: new Date(),
                                  startTime: convertToCentralTime(new Date()),
                              }
                            : timer
                    )
                })
            } else if (info.type === 'changeStage') {
                setOrderStage(info.stage)
            }
            setEventLog((eventLog) => {
                return [...eventLog, message.data]
            })
        }
        client.current.onerror = function () {
            // console('Websocket error --- closed')
        }
        client.current.onclose = function (e: any) {
            // console('Socket is closed. Reconnect will be attempted in 1 second.', e.reason)
            setTimeout(function () {
                reconnect()
            }, 1000)
        }
    }, [techTimers, reconFlag])

    return [
        time,
        ticking,
        eventLog,
        techTimers,
        timerLog,
        toggleTimer,
        switchStage,
        changeOrderStage,
        orderStage,
    ]
}

interface Tech {
    TechUsername: string
    WarehouseId: number
    FullName: string
}

// forwards ref so formcontainer can call timer funcs without having to rerender itself -- in redux world this wouldnt be needed
function App({ orderTagId, orderTagStage, currentUser, recordId }, ref) {
    // const currentUser = "MORGAN"
    const [
        timer,
        ticking,
        eventLog,
        techTimers,
        timerLog,
        toggleTimer,
        switchStage,
        changeOrderStage,
        orderStage,
    ] = useTimer(orderTagId, recordId)
    const [cTech, setTech] = React.useState({ TechUsername: currentUser })
    const [cStage, setStage] = React.useState(orderTagStage)
    const [stageList, setStageList] = React.useState<Array<any>>([])
    // need to know when setStage was called from a user event or from the cTech useEffect attaching to existing timer
    const [automatedAction, setAutomatedAction] = React.useState(false)
    const [loading, setLoading] = React.useState(true)

    const [techList, setTechList] = React.useState<Array<Tech>>([])

    const getTechList = async () => {
        setLoading(true)
        let request = await fetch(TECHS_URL, { credentials: 'include' })
        let json = await request.json()
        json.sort((a, b) => (a.WarehouseId < b.WarehouseId ? -1 : 1))
        setTechList(json)
        setLoading(false)
    }

    React.useEffect(() => {
        let currentTimer = techTimers.find((timer) => timer.tech === cTech.TechUsername)
        if (currentTimer) {
            setStage(currentTimer.stage)
            setAutomatedAction(true)
        }
    }, [cTech])

    React.useEffect(() => {
        if (currentUser) setTech({ TechUsername: currentUser })
    }, [currentUser])

    React.useImperativeHandle(ref, () => ({
        startTimer: (stage) => {
            let oldTimer = techTimers.find((timer) => timer.tech === currentUser)
            if (!techList.find((tech) => tech.TechUsername === currentUser)) return
            if (oldTimer) {
                if (oldTimer.stage === stage) return
                switchStage(currentUser, oldTimer.stage, stage)
            } else toggleTimer(currentUser, stage)
        },
        stopTimer: () => {
            let oldTimer = techTimers.find((timer) => timer.tech === currentUser)
            if (!techList.find((tech) => tech.TechUsername === currentUser)) return
            if (oldTimer) toggleTimer(currentUser, oldTimer.stage)
        },
        switchTimer: (newStage) => {
            let oldTimer = techTimers.find((timer) => timer.tech === currentUser)
            if (oldTimer) switchStage(currentUser, oldTimer.stage, newStage)
        },
        changeStage: (newStage, canCompleteAs) => {
            if (newStage.toUpperCase().startsWith('COMPLETED'))
                changeOrderStage(newStage, canCompleteAs)
            else changeOrderStage(newStage, currentUser)
        },
    }))

    const getStageList = async () => {
        let request = await fetch(STAGES_URL, { credentials: 'include' })
        let json = await request.json()
        setStageList(json)
    }

    const TimerText = ({ startTime }) => {
        const [refresh, setRefresh] = React.useState([])

        React.useEffect(() => {
            let handle = setInterval(() => setRefresh([]), 1000)
            return () => clearInterval(handle)
        }, [])

        let currentTimerObj = getTotalTime(startTime, new Date())
        let longFormat = currentTimerObj.hours > 0
        return (
            <div style={{ display: 'inline-block' }} className={longFormat ? 'TimeLong' : 'Time'}>
                {`${
                    currentTimerObj.hours > 0
                        ? currentTimerObj.hours.toString().padStart(2, '0') + ':'
                        : ''
                }${currentTimerObj.minutes.toString().padStart(2, '0')}:${currentTimerObj.seconds
                    .toString()
                    .padStart(2, '0')}`}
            </div>
        )
    }
    React.useEffect(() => {
        getStageList()
        getTechList()
    }, [])

    const techObj = techList.find((tech) => tech.TechUsername === currentUser)
    const currentTechFullName = techObj ? techObj.FullName : ''
    const currentTimer = techTimers.find((techTimer) => techTimer.tech === cTech.TechUsername)
    let currentStage = orderStage || orderTagStage

    if (loading || !techList.find((tech) => tech.TechUsername === currentUser)) return null
    return ReactDOM.createPortal(
        <div
            onTouchEnd={(e) => {
                document.body.ontouchmove = (e) => {}
            }}
            onTouchStart={(e) => {
                document.body.ontouchmove = (e) => {
                    e.preventDefault()
                    return false
                }
            }}
        >
            <Draggable position={{ translateX: 0, translateY: 0 }}>
                {({ translateX, translateY }) => (
                    <div
                        className='widgetContainer'
                        style={{
                            transform: `translate3d(${translateX}px, ${translateY}px, 0)`,
                        }}
                    >
                        <div className='Rectangle-17'>
                            <div className='Tech-Name'>{currentTechFullName}</div>
                            <div className='Recieved-Pending-Evaluation'>{currentStage}</div>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    height: 75,
                                    alignItems: 'center',
                                }}
                            >
                                {currentTimer ? (
                                    <>
                                        <div className='centeredText'>
                                            <StopIcon
                                                className='Path-7'
                                                onClick={() =>
                                                    toggleTimer(currentUser, currentTimer.stage)
                                                }
                                            />
                                        </div>

                                        <TimerText startTime={currentTimer.startTime} />
                                    </>
                                ) : (
                                    <>
                                        <div className='centeredText'>
                                            <PlayIcon
                                                title=''
                                                className='Path-7'
                                                onClick={() =>
                                                    toggleTimer(currentUser, currentStage)
                                                }
                                            />
                                        </div>

                                        <div style={{ display: 'inline-block' }} className='Time'>
                                            00:00
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </Draggable>
        </div>,
        document.getElementById('root2')
    )
}

export default React.forwardRef(App)
